import styled from 'styled-components';
import uploadBg from '~/assets/img/upload-bg.png';

import 'antd/lib/alert/style/index.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  div:nth-child(2) {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxAuth = styled.div`
  width: 1068px;
  min-height: 600px;
  padding: 40px;
  margin: 0 auto;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;
  div.BoxAuthContainer {
    margin: 20px auto;
    div.title {
      margin-bottom: 33px;
      h2 {
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: 0.01px;
        text-align: center;
        color: #282828;
        span {
          font-weight: bold;
          color: #74a50a;
        }
      }
    }

    div.selectMonth {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 60px;

      .ant-select-selection {
        background-color: #ebeaea;
      }

      .ant-select-selection--single {
        height: 38px;
      }

      .ant-select-selection__rendered {
        line-height: 38px;
      }

      .ant-select-selection:hover {
        border-color: #74a50a;
      }
      .ant-select-focused .ant-select-selection,
      .ant-select-selection:focus,
      .ant-select-selection:active {
        border-color: #74a50a;
        border-right-width: 1px !important;
        outline: 0;
        -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }

      .ant-select-open .ant-select-selection {
        border-color: #74a50a;
      }

      .ant-select-dropdown.ant-select-dropdown--multiple
        .ant-select-dropdown-menu-item-selected
        .ant-select-selected-icon,
      .ant-select-dropdown.ant-select-dropdown--multiple
        .ant-select-dropdown-menu-item-selected:hover
        .ant-select-selected-icon {
        display: inline-block;
        color: #74a50a;
      }
    }
  }
  hr {
    opacity: 0.1;
    display: block;
    margin: 60px 0;
  }

  div.ant-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    h2 {
      font-size: 20px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.22;
      letter-spacing: 0.01px;
      text-align: center;
      color: #282828;
      margin-bottom: 25px;
    }
  }

  div.alertMessage {
    width: 365px;
    margin: 40px auto 0 auto;

    .ant-alert-success {
      background-color: rgba(116, 165, 10, 0.16);
      border: 1px solid #a4c951;
      .ant-alert-message {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.1;
        letter-spacing: 0.09px;
        text-align: left;
        color: #74a50a;
      }
    }
  }

  .colInsercao {
    border-right: 1px solid #707070;
  }
`;

export const BoxUpload = styled.div`
  width: 365px;
  height: 249px;
  margin: 0 auto;
  border-radius: 8px;
  border: 2px dashed #d9e9ed;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    input {
      display: none;
    }
    label {
      background-image: url(${uploadBg});
      background-repeat: no-repeat;
      background-position: center 30px;
      display: block;
      width: 365px;
      height: 249px;
      cursor: pointer;
      position: absolute;
      color: #ffffff;
      /* background-color: red; */
      z-index: 40;
    }
    span.fileUploadText {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.13;
      letter-spacing: 0.01px;
      text-align: center;
      color: #6c6c6c;
      display: block;
      margin: 5px 0;
      position: relative;
      top: 30px;
    }
  }

  div.loadingFile {
    padding-top: 80px;
    text-align: center;
    span {
      font-size: 12px;
      display: block;
      color: #6c6c6c;
      margin-top: 15px;
    }
  }
`;

export const BoxSendButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: absolute;
  top: 50px;
  z-index: 10;
  button {
    width: 150px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
`;

export const BoxInstructions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
  span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 3;
    letter-spacing: normal;
    text-align: center;
    color: #6c6c6c;
  }
  p {
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #235f6e;
    text-decoration: underline;
  }
  a {
    color: #235f6e;
  }
`;

export const BoxFichaColeta = styled.div`
  width: 320px;
  height: 245px;
  border-radius: 8px;
  border: solid 1.5px #eaeaea;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: center;
    color: #333333;
    display: block;
    padding: 15px 0;
  }
`;
